module.exports = require('./lib/jsurl');


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsurl-moment/index.js
 ** module id = 3
 ** module chunks = 0
 **/